module.exports = __webpack_public_path__ + "static/img/2dbg_2.e7855105.png";